import { render, staticRenderFns } from "./InformalSector.vue?vue&type=template&id=359b819c&scoped=true&"
import script from "./InformalSector.vue?vue&type=script&lang=js&"
export * from "./InformalSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b819c",
  null
  
)

export default component.exports